import React, { useState } from "react";
import { HiOutlineCheckCircle } from "react-icons/hi";
import InputField from "../../common/InputField";
import { DiePurchaseOrderAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import { FormFooter } from "../../common/Shared";
import Model from "../../common/Model";

const DieInwardModal = ({ selectedItems, onClose, onSuccess }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const today = new Date().toISOString()?.split("T")[0];

  const [loading, setLoading] = useState(false);
  const [inwardData, setInwardData] = useState({
    inward_Date: today,
    invoice_No: "",
  });

  const handleInputChange = (field, value) => {
    setInwardData((prev) => ({ ...prev, [field]: value }));
  };

  const handleInwardSubmit = async () => {
    if (!inwardData.invoice_No) {
      notify("Please enter Invoice/Challan Number", "warning");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        trnNos: selectedItems.map((item) => item.trn_No),
        inward_Date: inwardData.inward_Date,
        invoice_No: inwardData.invoice_No,
        created_By: userId,
      };

      const res = await DiePurchaseOrderAPI.processInward(payload);
      if (res.success) {
        notify("Dies inwarded successfully", "success");
        onSuccess();
      } else {
        notify(res.message || "Failed to process inward", "error");
      }
    } catch (error) {
      notify("Server error while processing inward", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Model
      isOpen={true}
      onClose={onClose}
      name="Process Die Inward"
      widthClass="max-w-2xl"
    >
      <div className="flex flex-col">
        {/* Selected Dies Summary */}
        <div className="p-6 border-b border-slate-100">
          <div className="flex justify-between items-center mb-3">
            <p className="text-[11px] font-black text-gray-500 uppercase tracking-[2px]">
              Selected Dies ({selectedItems.length})
            </p>
            <span className="text-[10px] text-slate-400 font-medium italic">
              All selected dies will share the same inward info
            </span>
          </div>
          <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto bg-slate-50 border border-slate-100 p-3">
            {selectedItems.map((item, i) => (
              <div
                key={i}
                className="px-3 py-1.5 bg-white border border-slate-200 flex items-center gap-2"
              >
                <span className="w-2 h-2 bg-primary"></span>
                <span className="text-[11px] font-black text-slate-700">
                  {item.dieNumber}
                </span>
                <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 font-mono">
                  PO#{item.pO_No}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Inward Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6 border-b border-slate-100">
          <InputField
            label="Inward Date"
            type="date"
            value={inwardData.inward_Date}
            onChange={(val) => handleInputChange("inward_Date", val)}
          />
          <InputField
            label="Invoice / Challan No"
            value={inwardData.invoice_No}
            onChange={(val) => handleInputChange("invoice_No", val)}
            placeholder="Enter reference number"
          />
        </div>

        <FormFooter
          onCancel={onClose}
          onSubmit={handleInwardSubmit}
          submitText={
            loading
              ? "Processing..."
              : `Confirm Receipt (${selectedItems.length} Dies)`
          }
          isSaving={loading}
        />
      </div>
    </Model>
  );
};

export default DieInwardModal;
